import React from 'react';
import SbEditable from 'storyblok-react';

import Components from './components.js';
import '../styles/row.scss';

const Row = (props) => {
  const rowClasses = ['row'];
  if (props.blok.align_columns) {
    rowClasses.push('cols-' + props.blok.align_columns);
  }

  if (props.blok.column_content_align) {
    rowClasses.push('cca-' + props.blok.column_content_align);
  }

  if (props.blok.stretch) {
    rowClasses.push('stretch');
  }

  if (props.blok.no_content_padding) {
    rowClasses.push('no-content-padding');
  }

  return (
    <SbEditable content={props.blok}>
      <div className={`container${props.blok.fluid ? '-fluid' : ''}`}>
        <div className={rowClasses.join(' ')}>
          {props.blok.columns.map((blok) =>
            React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
          )}
        </div>
      </div>
    </SbEditable>
  );
};

export default Row;
